import React, { useState } from "react";
import { Avatar } from "../shared/Avatar";
import { CustomIcon } from "../shared/CustomIcon";
import { fullName, formatDate } from "../../lib/format";
import StructuralBackButton from "../shared/StructuralBackButton";

function ReportsPage({ members, attendance, followups, users, services }) {
  const [tab, setTab] = useState("membership");
  const byStatus={}, byMarital={}, byLanguage={}, byDept={};
  members.forEach(m=>{byStatus[m.memberStatus]=(byStatus[m.memberStatus]||0)+1;byMarital[m.maritalStatus]=(byMarital[m.maritalStatus]||0)+1;byLanguage[m.language]=(byLanguage[m.language]||0)+1;m.departments.forEach(d=>{byDept[d]=(byDept[d]||0)+1;});});
  const attRates=services.map(s=>{const recs=attendance.filter(a=>a.serviceId===s.id);const tp=recs.reduce((sum,a)=>sum+Object.values(a.records).filter(v=>v==="present").length,0);const tt=recs.reduce((sum,a)=>sum+Object.values(a.records).length,0);return{service:s.name,rate:tt?Math.round(tp/tt*100):0,sessions:recs.length};});
  const teamStats=users.filter(u=>u.role==="team_member").map(u=>{const fus=followups.filter(f=>f.teamMemberId===u.id);const last=[...fus].sort((a,b)=>new Date(b.date)-new Date(a.date))[0];return{name:u.name,total:fus.length,assigned:(u.assignedMembers||[]).length,lastActivity:last?.date,flagged:last?Math.floor((new Date()-new Date(last.date))/86400000)>30:true};});

  return (
    <div>
      <div className="tabs">
        <button className={`tab ${tab==="membership"?"active":""}`} onClick={()=>setTab("membership")}>Membership</button>
        <button className={`tab ${tab==="attendance"?"active":""}`} onClick={()=>setTab("attendance")}>Attendance</button>
        <button className={`tab ${tab==="followup"?"active":""}`} onClick={()=>setTab("followup")}>Follow-Up Team</button>
      </div>
      {tab==="membership"&&(<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:14}}><ReportCard title="By Status" data={byStatus}/><ReportCard title="By Marital Status" data={byMarital}/><ReportCard title="By Language" data={byLanguage}/><ReportCard title="By Department" data={byDept}/></div>)}
      {tab==="attendance"&&(<div className="card"><div className="card-header"><div className="card-title">Attendance by Service</div></div><div style={{padding:20}}>{attRates.map(a=>(<div key={a.service} style={{marginBottom:18}}><div className="flex justify-between mb-4"><span style={{fontSize:13,fontWeight:500}}>{a.service}</span><span style={{fontSize:12,color:"var(--text3)"}}>{a.sessions} sessions · {a.rate}%</span></div><div style={{height:8,background:"var(--cream2)",borderRadius:4,overflow:"hidden"}}><div style={{width:`${a.rate}%`,height:"100%",background:`linear-gradient(90deg,var(--charcoal),var(--gold))`,borderRadius:4}}/></div></div>))}</div></div>)}
      {tab==="followup"&&(<div className="card"><div className="card-header"><div className="card-title">Team Activity</div></div><div className="table-wrap"><table><thead><tr><th>Team Member</th><th>Assigned</th><th>Follow-Ups</th><th>Last Activity</th><th>Status</th></tr></thead><tbody>{teamStats.map(s=>(<tr key={s.name}><td>{s.name}</td><td>{s.assigned}</td><td>{s.total}</td><td>{s.lastActivity?formatDate(s.lastActivity):"Never"}</td><td>{s.flagged?<span className="badge badge-red"><CustomIcon name="warning" size={12} style={{marginRight:4}} />Inactive</span>:<span className="badge badge-green">Active</span>}</td></tr>))}</tbody></table></div></div>)}
    </div>
  );
}

function ReportCard({ title, data }) {
  const total=Object.values(data).reduce((a,b)=>a+b,0);
  const colors=["var(--charcoal)","var(--gold)","var(--green)","var(--blue)","var(--red)","var(--text3)"];
  return (
    <div className="card" style={{padding:18}}>
      <div style={{fontWeight:700,fontSize:13,color:"var(--charcoal)",marginBottom:14,fontFamily:"'Cinzel',serif",textTransform:"uppercase",letterSpacing:"0.03em"}}>{title}</div>
      {Object.entries(data).map(([k,v],i)=>(
        <div key={k} style={{marginBottom:10}}>
          <div className="flex justify-between mb-4"><span style={{fontSize:12,fontWeight:500}}>{k}</span><span style={{fontSize:11,color:"var(--text3)"}}>{v} ({total?Math.round(v/total*100):0}%)</span></div>
          <div style={{height:5,background:"var(--cream2)",borderRadius:3,overflow:"hidden"}}><div style={{width:`${total?v/total*100:0}%`,height:"100%",background:colors[i%colors.length],borderRadius:3}}/></div>
        </div>
      ))}
    </div>
  );
}

// ============================================================
// BAPTISM REPORT
// ============================================================
function BaptismReport({ members }) {
  const baptized = members.filter(m=>m.baptized).sort((a,b)=>new Date(a.baptizedDate)-new Date(b.baptizedDate));
  return (
    <div>
      <div className="flex items-center gap-10 mb-20 flex-wrap">
        <StructuralBackButton to="/reports/analytics" label="← Analytics" testId="baptism-back" />
        <div style={{fontSize:13,color:"var(--text3)",marginLeft:"auto"}}>{baptized.length} baptized members</div>
        <button className="btn btn-outline" onClick={()=>window.print()} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><CustomIcon name="printer" size={14} /> Print Report</button>
      </div>
      <div className="card">
        <div className="card-header"><div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><CustomIcon name="baptism" size={16} /> Baptism Report</div></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Member</th><th>Baptism Date</th><th>Baptized By</th><th>Location</th><th>Current Status</th></tr></thead>
            <tbody>
              {baptized.map(m=>(
                <tr key={m.id}>
                  <td><div className="flex items-center gap-8"><Avatar name={fullName(m)} photo={m.photo} memberId={m.id} status={m.memberStatus} style={{width:26,height:26,fontSize:10}}/><span style={{fontWeight:500}}>{fullName(m)}</span></div></td>
                  <td>{formatDate(m.baptizedDate)}</td>
                  <td>{m.baptizedBy||"—"}</td>
                  <td>{m.baptizedWhere||"—"}</td>
                  <td><span className={`badge ${m.memberStatus==="Active"?"badge-green":"badge-gray"}`}>{m.memberStatus}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {baptized.length===0&&<div className="empty"><div className="empty-icon"><CustomIcon name="baptism" size={40} /></div><div className="empty-text">No baptism records found</div></div>}
        </div>
      </div>
    </div>
  );
}

// ============================================================
// NEW MEMBERS REPORT
// ============================================================
function NewMembersReport({ members }) {
  const [period, setPeriod] = useState("month");
  const now = new Date();

  const filtered = members.filter(m => {
    if(!m.joinedDate) return false;
    const d = new Date(m.joinedDate);
    if(period==="week") { const weekAgo=new Date(now); weekAgo.setDate(now.getDate()-7); return d>=weekAgo; }
    if(period==="month") { return d.getMonth()===now.getMonth()&&d.getFullYear()===now.getFullYear(); }
    if(period==="year") { return d.getFullYear()===now.getFullYear(); }
    return true;
  }).sort((a,b)=>new Date(b.joinedDate)-new Date(a.joinedDate));

  const periodLabel = period==="week"?"This Week":period==="month"?"This Month":period==="year"?"This Year":"All Time";

  return (
    <div>
      <div className="flex items-center gap-10 mb-20 flex-wrap">
        <StructuralBackButton to="/reports/analytics" label="← Analytics" testId="newmembers-back" />
        <div style={{fontSize:13,color:"var(--text3)",marginLeft:"auto"}}>{filtered.length} new members — {periodLabel}</div>
        <div className="flex gap-8">
          <select value={period} onChange={e=>setPeriod(e.target.value)} style={{padding:"8px 12px",fontSize:13,borderRadius:8,border:"1.5px solid var(--cream2)",background:"var(--cream)",fontFamily:"Montserrat,sans-serif"}}>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
            <option value="all">All Time</option>
          </select>
          <button className="btn btn-outline" onClick={()=>window.print()} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><CustomIcon name="printer" size={14} /> Print</button>
        </div>
      </div>
      <div className="card">
        <div className="card-header"><div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><CustomIcon name="person" size={16} /> New Members — {periodLabel}</div></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Joined</th><th>How They Joined</th><th>Invited By</th><th>Department</th><th>Status</th></tr></thead>
            <tbody>
              {filtered.map(m=>{
                const inviter = m.invitedBy ? members.find(x=>x.id===m.invitedBy) : null;
                return(
                  <tr key={m.id}>
                    <td><div className="flex items-center gap-8"><Avatar name={fullName(m)} photo={m.photo} memberId={m.id} status={m.memberStatus} style={{width:26,height:26,fontSize:10}}/><span style={{fontWeight:500}}>{fullName(m)}</span></div></td>
                    <td>{formatDate(m.joinedDate)}</td>
                    <td>{m.additionType||"—"}</td>
                    <td>{inviter?fullName(inviter):"—"}</td>
                    <td>{m.departments[0]||"—"}</td>
                    <td><span className={`badge ${m.memberStatus==="Active"?"badge-green":m.memberStatus==="New Member"?"badge-gold":"badge-gray"}`}>{m.memberStatus}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filtered.length===0&&<div className="empty"><div className="empty-icon"><CustomIcon name="person" size={40} /></div><div className="empty-text">No new members in this period</div></div>}
        </div>
      </div>
    </div>
  );
}

// ============================================================
// FAMILY GROWTH REPORT
// ============================================================
function FamilyGrowthReport({ members, families }) {
  const [tab, setTab] = useState("growth");
  const newborns = members.filter(m=>m.additionType==="Newborn/Dedication").sort((a,b)=>new Date(b.additionDate)-new Date(a.additionDate));
  const marriages = members.filter(m=>m.maritalStatus==="Married"&&m.additionType==="Joined by decision").sort((a,b)=>new Date(b.joinedDate)-new Date(a.joinedDate));
  const deaths = members.filter(m=>m.subtractionType==="Death").sort((a,b)=>new Date(b.subtractionDate)-new Date(a.subtractionDate));
  const departures = members.filter(m=>m.subtractionType&&m.subtractionType!=="Death").sort((a,b)=>new Date(b.subtractionDate)-new Date(a.subtractionDate));

  return (
    <div>
      <div className="flex items-center gap-10 mb-12 flex-wrap">
        <StructuralBackButton to="/reports/analytics" label="← Analytics" testId="familygrowth-back" />
      </div>
      <div className="tabs">
        <button className={`tab ${tab==="growth"?"active":""}`} onClick={()=>setTab("growth")}>Additions</button>
        <button className={`tab ${tab==="departures"?"active":""}`} onClick={()=>setTab("departures")}>Departures & Deaths</button>
      </div>
      {tab==="growth"&&(
        <div style={{display:"grid",gap:14}}>
          <div className="card">
            <div className="card-header"><div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><CustomIcon name="baby" size={16} /> Newborns &amp; Dedications ({newborns.length})</div></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Name</th><th>Date Added</th><th>Family</th><th>Notes</th></tr></thead>
                <tbody>
                  {newborns.map(m=>{const fam=m.familyId?families.find(f=>f.id===m.familyId):null;return(<tr key={m.id}><td><span style={{fontWeight:500}}>{fullName(m)}</span></td><td>{formatDate(m.additionDate)}</td><td>{fam?fam.name:"—"}</td><td style={{fontSize:12,color:"var(--text2)"}}>{m.additionComment||"—"}</td></tr>);})}
                </tbody>
              </table>
              {newborns.length===0&&<div className="empty"><div className="empty-text">No newborn records</div></div>}
            </div>
          </div>
          <div className="card">
            <div className="card-header"><div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><CustomIcon name="wedding" size={16} /> Married Members ({marriages.length})</div></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Name</th><th>Joined</th><th>Family</th><th>Department</th></tr></thead>
                <tbody>
                  {marriages.map(m=>{const fam=m.familyId?families.find(f=>f.id===m.familyId):null;return(<tr key={m.id}><td><span style={{fontWeight:500}}>{fullName(m)}</span></td><td>{formatDate(m.joinedDate)}</td><td>{fam?fam.name:"—"}</td><td>{m.departments[0]||"—"}</td></tr>);})}
                </tbody>
              </table>
              {marriages.length===0&&<div className="empty"><div className="empty-text">No records</div></div>}
            </div>
          </div>
        </div>
      )}
      {tab==="departures"&&(
        <div style={{display:"grid",gap:14}}>
          <div className="card">
            <div className="card-header"><div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><CustomIcon name="dove" size={16} /> Deaths ({deaths.length})</div></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Name</th><th>Date</th><th>Family</th><th>Notes</th></tr></thead>
                <tbody>
                  {deaths.map(m=>{const fam=m.familyId?families.find(f=>f.id===m.familyId):null;return(<tr key={m.id}><td><span style={{fontWeight:500}}>{fullName(m)}</span></td><td>{formatDate(m.subtractionDate)}</td><td>{fam?fam.name:"—"}</td><td style={{fontSize:12,color:"var(--text2)"}}>{m.subtractionComment||"—"}</td></tr>);})}
                </tbody>
              </table>
              {deaths.length===0&&<div className="empty"><div className="empty-text">No records</div></div>}
            </div>
          </div>
          <div className="card">
            <div className="card-header"><div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><CustomIcon name="logout" size={16} /> Departures ({departures.length})</div></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Name</th><th>Date</th><th>Reason</th><th>Notes</th></tr></thead>
                <tbody>
                  {departures.map(m=>(<tr key={m.id}><td><span style={{fontWeight:500}}>{fullName(m)}</span></td><td>{formatDate(m.subtractionDate)}</td><td><span className="badge badge-red">{m.subtractionType}</span></td><td style={{fontSize:12,color:"var(--text2)"}}>{m.subtractionComment||"—"}</td></tr>))}
                </tbody>
              </table>
              {departures.length===0&&<div className="empty"><div className="empty-text">No departure records</div></div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export { ReportsPage, BaptismReport, NewMembersReport, FamilyGrowthReport };
